import React from 'react';
import { ShieldCheck, Heart, Users, Clock, Bell } from 'lucide-react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: ShieldCheck,
      title: 'Fully Insured & DBS Checked',
      description: 'Fully vetted, background-checked, and comprehensively insured for your complete peace of mind.'
    },
    {
      icon: Clock,
      title: 'Reliable, Flexible and Local',
      description: 'Visit times arranged to suit your routine. Based locally across Merseyside and surrounding areas.'
    },
    {
      icon: Heart,
      title: 'Friendly and Professional Support',
      description: 'Caring support delivered with warmth, respect, and genuine understanding of your needs.'
    },
    {
      icon: Users,
      title: 'Personalised Service',
      description: 'Support tailored to individual needs and preferences — no one-size-fits-all approach.'
    },
    {
      icon: Bell,
      title: 'Family Updates Available',
      description: 'We keep families informed and reassured with regular updates on their loved one\'s wellbeing.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider"></span>
          <h2 className="text-4xl font-bold text-slate-900 mt-2 mb-4">
            Why Choose AFT Senior Assisted Services
          </h2>
          <p className="text-lg text-slate-600">
            We are committed to providing exceptional support that helps individuals maintain their independence and quality of life at home.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="group relative p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-white border-2 border-slate-100 hover:border-teal-200 transition-all duration-300 hover:shadow-lg"
              >
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-xl blur-lg opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                  <div className="relative w-16 h-16 bg-gradient-to-br from-cyan-100 to-teal-100 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-teal-700" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{reason.title}</h3>
                <p className="text-slate-600 leading-relaxed">{reason.description}</p>
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-teal-400 to-cyan-400 opacity-0 group-hover:opacity-10 rounded-bl-full transition-opacity duration-300"></div>
              </div>
            );
          })}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-8 p-8 bg-gradient-to-r from-cyan-50 via-teal-50 to-emerald-50 rounded-2xl border border-teal-100">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md">
                <ShieldCheck className="w-6 h-6 text-teal-600" />
              </div>
              <div className="text-left">
                <p className="text-sm text-slate-600">Fully Certified</p>
                <p className="font-bold text-slate-900">DBS Checked</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md">
                <ShieldCheck className="w-6 h-6 text-teal-600" />
              </div>
              <div className="text-left">
                <p className="text-sm text-slate-600">Protected</p>
                <p className="font-bold text-slate-900">Fully Insured</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md">
                <Heart className="w-6 h-6 text-teal-600" />
              </div>
              <div className="text-left">
                <p className="text-sm text-slate-600">Always</p>
                <p className="font-bold text-slate-900">Compassionate</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a href="tel:07475473449">
            <Button size="lg" className="bg-teal-600 hover:bg-teal-700 text-white px-10 py-6 text-lg">
              <Phone className="mr-2 w-5 h-5" />
              Call Us Today — 07475 473 449
            </Button>
          </a>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
